<div *ngIf="hasFiltri"  class="card-body align-middle">
  <div class="row align-middle">
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'container.inizio' | translate}}</label>
      <input type="date" #inizio = "ngModel"  [(ngModel)]="Filtri.inizio" (ngModelChange)="refreshTable(1)" name="inizio" class="form-control">
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'container.fine' | translate}}</label>
      <input type="date" #fine = "ngModel"  [(ngModel)]="Filtri.fine" (ngModelChange)="refreshTable(1)" name="fine" class="form-control">
    </div>
    <div class="col-lg-1 align-middle">
      <label class="control-label col-form-label">{{'container.periodo' | translate}}</label>
      &nbsp;
      <input type="checkbox" #periodo = "ngModel" [(ngModel)]="Filtri.periodo" (ngModelChange)="refreshTable(1)" name="periodo" >
    </div>
    <div class="col-sm-12 col-md-3">
      <div class="form-group">
        <label for="fornitore" class="control-label col-form-label">{{'container.stati' | translate}}</label>
        <ng-multiselect-dropdown [settings]="DropdownSettings" [placeholder]="'container.stati' | translate" id="fornitore"
                                 [data]="Stati" [(ngModel)]="StatiSelezionati" (ngModelChange)="refreshTable(1)" >
        </ng-multiselect-dropdown>
      </div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center bg-white p-3">
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{'menu.container' | translate}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
  <div class="ml-auto mt-3 mt-md-0">
    <app-stampa [Stampe]="stampe" *ngIf="stampe && stampe.length > 0" [(data)]="List"></app-stampa>
  </div>
  <div class=" mt-3 mt-md-0">
    <button *ngIf="permission.isPermitted('gestione-container') && isAddEnabled" (click)='Edit()' type="button" class="btn btn-cyan rounded-pill py-2" ><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'container.add' | translate}}</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
    <tr>
      <th scope="col" >
        <input type="checkbox" [(ngModel)]="SelectAll" name="list_name" value="h1" (change)="checkUncheckAll()" />
      </th>
      <th>{{'container.targa' | translate}}</th>
      <th scope="col">{{'container.data' | translate}}</th>
      <th scope="col">{{'container.arrivo' | translate}}</th><!-- le label sono state invertite nel file di traduzione-->
      <th scope="col">{{'agenzia' | translate}}</th>
      <th scope="col" *ngIf="permission.isPermitted('gestione-container')">{{'container.azioni' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of List | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
      <td  class="align-middle"  >
        <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name" (change)="CheckIfAllSelected()" />
      </td>
      <td (click)='Edit(item)'>
        <span class="font-14">{{item.targa}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{ item.arrivo | date: 'dd/MM/yyyy'}}</span> <!-- le label sono state invertite nel file di traduzione-->
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{ item.data | date: 'dd/MM/yyyy'}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{ item.agenzia }}</span>
      </td>
      <td class="align-middle">
        <a href="javascript:void(0)" ngbTooltip="VediProdotti" class="link font-16 text-info font-medium mr-2"
           (click)="ViewProd(item, p1)" [ngbPopover]="tipContentss"
           [autoClose]="'outside'"
           triggers="manual"
           #p1="ngbPopover"
           placement="bottom"
           popoverTitle="Voci"
        >
          <i class="fas fa-eye"></i>
        </a>
        <ng-template #tipContentss>
          <div class="row" *ngFor="let element of listaPopup">
            <span class="px-3 font-14">{{element.voce}}&nbsp; {{element.quantita}} Pz</span>
            <hr>
          </div>
        </ng-template>
        <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
           (click)="Edit(item)">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" ngbTooltip="Elimina"
           class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
                  [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>

